module.exports = __webpack_public_path__ + "static/work37-168fea6dd0ef3f9dfc75e67160ee306a.jpg";